// Single money formatter for the app. amountCents is integer minor units.
export const formatMoney = (amountCents, currency) =>
    new Intl.NumberFormat(undefined, { style: 'currency', currency: (currency || 'usd').toUpperCase() }).format(amountCents / 100);
